import Modal from "react-modal";
import { AiOutlineClose } from "react-icons/ai";
import { IconContext } from "react-icons";
import styled from "styled-components";
import { CustomButton } from "../customButton";
import { useEffect, useState } from "react";
import { Notify, Utils } from "../../utils";
import { toast } from "react-toastify";
import { CPFService } from "../../_service/CPFService";
import { useAppSelector } from "../../_app";
import moment from "moment";
import { IoWarningOutline } from "react-icons/io5";

interface CreateCPFModalProps {
  body?: string | JSX.Element;
  open: boolean;
  cpfList?: any;
  handleClose: () => void;
}

const customStyles = {
  content: {
    top: "45%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "1px solid #eee",
    borderRadius: "10px",
    maxWidth: "500px",
    padding: 0,
  },
  overlay: {
    zIndex: 100,
    backgroundColor: "rgba(0,0,0,0.5)",
  },
};

const CreateCPFModal = (props: CreateCPFModalProps) => {
  const { handleClose, open } = props;

  const [selectedMonth, setSelectedMonth] = useState(
    String(moment().month() + 1)
  );
  const [selectedYear, setSelectedYear] = useState(moment().format("YYYY"));

  const [loading, setLoading] = useState(false);

  const [showWarning, setShowWarning] = useState(false);

  const companyId = useAppSelector((state: any) => state.user.defaultCompnayId);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const years = Array.from({ length: 10 }, (_, i) =>
    (new Date().getFullYear() - 5 + i).toString()
  );

  const handleCreateCPF = async () => {
    try {
      if (!selectedMonth || !selectedYear) {
        Notify("Please select both month and year.", 0);
        return;
      }

      setLoading(true);
      const res = await CPFService._createCPF({
        month: selectedMonth,
        year: selectedYear,
        value: 0,
        companyId: companyId,
      });

      if (res.status >= 200 && res.status < 300) {
        Notify("CPF created successfully.", 1);
        window.location.reload();
        handleClose();
      }
    } catch (error: any) {
      Utils.showErrorMessage(error);
    } finally {
      setLoading(false);
    }
  };

  console.log("Selected Month:", selectedMonth);
  console.log("Selected Year:", selectedYear);
  console.log("inside CPF Modal", props.cpfList);


  useEffect(() => {

    let cpfExists = false;
    let formattedDate = moment(`${selectedMonth} ${selectedYear}`, "MM YYYY").format("MMMM YYYY");

    let existingCPFDates = Object.keys(props.cpfList || {});
    console.log('existing CPF Dates:', existingCPFDates, formattedDate);

    if (existingCPFDates.includes(formattedDate)) {
      cpfExists = true;
    }

    setShowWarning(cpfExists);
  }, [selectedMonth, selectedYear]);

  return (
    <Modal
      isOpen={open}
      onRequestClose={handleClose}
      style={customStyles}
      contentLabel="Select Month and Year"
      ariaHideApp={false}
    >
      <div>
        <Header>
          <h3>Select Month and Year</h3>
          <span onClick={handleClose}>
            <IconContext.Provider value={{ color: "red", size: "20px" }}>
              <AiOutlineClose />
            </IconContext.Provider>
          </span>
        </Header>

        {showWarning && (
          <div
            style={{
              // margin: "1rem",
              padding: "12px 16px",
              backgroundColor: "#fff3cd",
              color: "#856404",
              border: "1px solid #ffeaa7",
              // borderLeft: "4px solid #ef4444",
            }}
          >
            <div
              style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}
            >
              <IoWarningOutline
                size={64}
                stroke="#efb701"
                style={{ color: "#000", strokeWidth: 8 }}
              />
              <div>
                <p
                  style={{
                    fontSize: "1rem",
                    margin: 0,
                    lineHeight: "1.5",
                    fontStyle: "italic",
                  }}
                >
                  The CPF for the selected month and year already exists, if
                  it's finalized, a new CPF will be created, else the existing
                  CPF will be overridden.
                </p>
              </div>
            </div>
          </div>
        )}
        <Body>
          <FormGroup>
            <Label>Month:</Label>
            <Select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
            >
              <option value="">Select Month</option>
              {Utils.MONTH_OPTIONS.map((month) => (
                <option key={month.key} value={month.value}>
                  {month.key}
                </option>
              ))}
            </Select>
          </FormGroup>
          <FormGroup>
            <Label>Year:</Label>
            <Select
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
            >
              <option value="">Select Year</option>
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </Select>
          </FormGroup>
        </Body>
        <Footer>
          <CustomButton
            title="Create CPF"
            onClick={handleCreateCPF}
            loading={loading}
            disable={loading || !selectedMonth || !selectedYear}
          />
          <CustomButton title="Cancel" type="secondary" onClick={handleClose} />
        </Footer>
      </div>
    </Modal>
  );
};

export default CreateCPFModal;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #059bbf;
  padding: 10px 20px 20px 20px;
  h3 {
    color: #059bbf;
  }
  span {
    cursor: pointer;
  }
`;

const Body = styled.div`
  padding: 40px;
`;

const Footer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: #f5f5f5;
  padding: 14px 15px 15px;
  border-top: 1px solid #059bbf;
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Label = styled.label`
  min-width: 80px;
  color: grey;
`;

const Select = styled.select`
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 200px;
  &:focus {
    outline: none;
    border-color: #059bbf;
  }
`;

const WarningCard = styled.div`
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  color: #856404;
  padding: 15px 20px;
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

const WarningIcon = styled.div`
  flex-shrink: 0;
  margin-top: 2px;
`;

const WarningContent = styled.div`
  flex: 1;
`;
